const IMPACT_LABELS: Record<number, string> = {
  5: 'Urgent',
  4: 'High',
  3: 'Medium',
  2: 'Low',
  1: 'Info',
}

const IMPACT_COLORS: Record<number, string> = {
  5: 'red',
  4: 'orange',
  3: 'gold',
  2: 'blue',
  1: 'default',
}

export function impactLabel(score: number): string {
  return IMPACT_LABELS[score] ?? String(score)
}

export function impactColor(score: number): string {
  return IMPACT_COLORS[score] ?? 'default'
}

export function formatSnakeCase(value: string): string {
  if (value === 'missing_from_platform') {
    return 'Missing from sureCo'
  }
  if (value === 'missing_from_carrier') {
    return 'Missing from Noyo'
  }
  if (value === 'unavailable_at_carrier') {
    return 'Unavailable at carrier'
  }
  return value.replace(/_/g, ' ')
}

export function formatUnixTime(unix?: number): string {
  if (unix == null) {
    return '—'
  }
  return new Date(unix * 1000).toLocaleString()
}
